import React, { useCallback, useEffect, useRef, useState } from "react";
import "./index.css";
import {
  Badge,
  BlockStack,
  Box,
  Button,
  Card,
  InlineStack,
  Link,
  Page,
  ProgressBar,
  Toast,
  Layout,
  SkeletonBodyText,
  Icon,
  Tooltip,
} from "@shopify/polaris";
import intl from "../../../../i18n/intl";
import {
  reqGetCurrentStoreInfo,
  reqGetNewSubscribeLimit,
  reqGetNewSubscribeList,
  reqPostNewSubscribeChange,
} from "../../../../api";
import {ChevronUpIcon,ChevronDownIcon,DiscountIcon,QuestionCircleIcon} from "@shopify/polaris-icons";
import defalutData from "../../SubscriptionPaid/components/subData";
import SearchLoading from "../../../../components/SearchLoading";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import utils from "../../../../utils/utils";
import PersonalAgentModal from "../../SubscriptionPaid/components/PersonalAgentModal";
import { store } from "../../../../store";
import { changePersonLevel, setInitialPath } from "../../../../slice";
const PlanClass = ({handleModalCallback}) => {
  const [toast, setToast] = useState(false); // 提示
  const router = useHistory();
  const shopify = window.shopify;
  const [toastError, setToastError] = useState(false);
  const [toastMsg, setToastMsg] = useState("");
  const [initPage, setInitPage] = useState(true); //页面初始化
  const [pageLoading, setPageLoading] = useState(false); // 页面加载中
  const [showAllFeature, setShowAllFeature] = useState(false); // 是否展示所有feature
  const [planData, setPlanData] = useState({
    glassesLevel: 0,
    bill_next_time: 0,//账单截止时间
    list: {
    "name": "Free",
    "dsc": "All necessary features for growing business",
    "symbol": "$",
    "id": 1,
    "title_icon": "/order_fulfillment/pro_icon.png",
    "popular": "",
    "price": "0",
    "oldPrice": "0",
    "date": "Monthly",
    "isFree": false,
    "type": 1,
    "button": "Current Plan",
    "link": "",
    "discount": 1,
    "discount_time": 0,
    "discount_day": 1,
    "money": 0,
    "loading": false,
    "disabled": true,
    "level": 1,
    "limitation": {
        "sourcing_num": 3,
        "ali_product_num": 10,
        "dsm_product_num": 10,
        "temu_product_num": 10
    },
    "common": [],
    "dscList": [],
    "key": 1,
    "is_yearly": 1,
    "is_allowed": 1,
    "is_discount_pop": 0,
    "first_purchase": false,
    "is_zt": false,
    "bill_level": 1,
    "agent": []
},
    currentPlanYear: {},
  }); // 套餐数据
  const [planQuotaList, setPlanQuotaList] = useState({
    limit: {
      sourcing: 0,
      sourcing_job: 0,
      aliexpress: 0,
      aliexpress_job: 0,
      dsm: 0,
      temu: 0,
      temu_job: 0,
      use_sourcing: 0,
      use_product: 0,
    },
    total: {
      sourcing_num: 3,
      ali_product_num: 10,
      dsm_product_num: 10,
      temu_product_num: 10,
      add_sourcing: 0,
      add_product: 0,
    },
  });
  const [subList, setSubList] = useState(defalutData.subList); // 套餐列表
  const [sourcingQuotaList, setSourcingQuotaList] = useState(sourcingRecharge); // sourcing量加量包
  const [importQuotaList, setImportQuotaList] = useState(importRecharge); // 导入量加量包
  // 高级套餐
  const [premiumData, setPremiumData] = useState({
    open: false,
    agent_list: [],
  });
  const handlePremiumOff = () => {
    setPremiumData((prevValue) => ({
      ...prevValue,
      open: false,
    }));
  };
  const enhancePackageList = (
    list,
    currentPlanId,
    pricingData,
    trialDays,
    agentList,
    firstPurchase,
    isZt,
    glassesLevel
  ) =>
    list.map((item) => {
      const priceInfo = pricingData.find((p) => p.key === item.id) || {};
      const isCurrentPlan = item.id === currentPlanId;
      const isAnnualPlan = priceInfo?.is_yearly === 1;
      let button = "";
      let disabled = false;
      if (glassesLevel === 1) {
        // 当前为年套餐页
        if (isAnnualPlan) {
          if (isCurrentPlan) {
            // 当前为年套餐页、未购买年套餐的
            if (currentPlanId === 0) {
              // 未付费用户
              button = "Current Plan";
              disabled = true;
            } else if (item.id === 0) {
              button = "Downgrade";
            } else {
              button = "Current Plan";
              disabled = true;
            }
          } else if (
            (item.id === 0 && item.id !== currentPlanId) ||
            (item.id === 4 && currentPlanId !== 0 && !isCurrentPlan)
          ) {
            button = "Downgrade";
          } else if (currentPlanId !== 4 && item.id < currentPlanId) {
            button = "Downgrade";
          } else if (trialDays !== 0 && item.id !== 4) {
            button = `Start ${trialDays}-day free trial`;
          } else {
            button = "Select Plan";
          }
        } else {
          if (isCurrentPlan) {
            if (currentPlanId === 0) {
              // 未付费用户
              button = "Current Plan";
              disabled = true;
            } else if (item.id === 4 && currentPlanId === 0) {
              button = "Select Plan";
            } else {
              button = "Downgrade";
            }
          } else if (
            (item.id === 0 && item.id !== currentPlanId) ||
            (item.id === 4 && currentPlanId !== 0 && !isCurrentPlan)
          ) {
            if (item.id === 4 && currentPlanId === 0) {
              button = "Select Plan";
            } else {
              button = "Downgrade";
            }
          } else if (currentPlanId !== 4 && item.id < currentPlanId) {
            button = "Downgrade";
          } else if (trialDays !== 0 && item.id !== 4) {
            button = `Start ${trialDays}-day free trial`;
          } else {
            if (item.id === 4 && currentPlanId === 0) {
              button = "Select Plan";
            } else {
              button = "Downgrade";
            }
          }
        }
      } else {
        if (isAnnualPlan) {
          if (isCurrentPlan) {
            // 当前为年套餐页、未购买年套餐的
            if (currentPlanId === 0) {
              // 未付费用户
              button = "Current Plan";
              disabled = true;
            } else if (item.id === 0) {
              button = "Downgrade";
            } else if (trialDays !== 0 && item.id !== 4) {
              button = `Start ${trialDays}-day free trial`;
            } else {
              button = "Select Plan";
            }
          } else if (item.id === 0 && item.id !== currentPlanId) {
            button = "Downgrade";
          } else if (trialDays !== 0 && item.id !== 4) {
            button = `Start ${trialDays}-day free trial`;
          } else {
            button = "Select Plan";
          }
        } else {
          if (isCurrentPlan) {
            if (currentPlanId === 0) {
              // 未付费用户
              button = "Current Plan";
              disabled = true;
            } else if (item.id === 0) {
              button = "Downgrade";
            } else {
              button = "Current Plan";
              disabled = true;
            }
          } else if (
            (item.id === 0 && item.id !== currentPlanId) ||
            (item.id === 4 && currentPlanId !== 0 && !isCurrentPlan)
          ) {
            button = "Downgrade";
          } else if (currentPlanId !== 4 && item.id < currentPlanId) {
            button = "Downgrade";
          } else if (trialDays !== 0 && item.id !== 4) {
            button = `Start ${trialDays}-day free trial`;
          } else {
            button = "Select Plan";
          }
        }
      }

      return {
        ...item,
        ...priceInfo,
        first_purchase: firstPurchase,
        is_zt: isZt,
        level:currentPlanId,
        bill_level: currentPlanId,
        agent: item.id === 5 ? agentList : [],
        button,
        disabled,
        loading: false,
      };
    });
  // 获取套餐数据
  const getSubscribeList = async () => {
    try {
      let res = await reqGetNewSubscribeList();
      if (shopify) {
        const response = await reqGetCurrentStoreInfo();
        if (response.code === "200") {
          let getData = response.data;
          store.dispatch(changePersonLevel({ infoData: getData }, true));
        }
      }
      if (res.code === "200") {
        getPackageQuota();
        const {
          level,
          trial_days,
          agent_list,
          one_package,
          first_purchase,
          is_zt,
          glasses_level,
          bill_next_time,
          reset_time
        } = res.data;
        setPremiumData((prevValue) => ({
          ...prevValue,
          agent_list: res.data.agent_list,
        }));
        if (level === 0) {
          setShowAllFeature(true)
        }
        // 处理月套餐
        const enhancedMonth = enhancePackageList(
          subList.month,
          level,
          res.data.package.month,
          trial_days,
          agent_list,
          first_purchase,
          is_zt,
          glasses_level
        );
        
        // 处理年套餐
        const enhancedYear = enhancePackageList(
          subList.year,
          level,
          res.data.package.year,
          trial_days,
          agent_list,
          first_purchase,
          is_zt,
          glasses_level
        );
        let currentPlan = {};
        if (glasses_level === 1) {
          currentPlan = enhancedYear.filter(
            (item, ind) => item.id === level
          )[0];
        } else {
          currentPlan = enhancedMonth.filter(
            (item, ind) => item.id === level
          )[0];
        }
        
        

        setPlanData((prev) => ({
          ...prev,
          bill_next_time,
          reset_time,
          glassesLevel: glasses_level,
          list: currentPlan,
          currentPlanYear: enhancedYear.filter(
            (item, ind) => item.id === level
          )[0],
        }));
        setSubList((prev) => ({
          ...prev,
          month: enhancedMonth,
          year: enhancedYear,
        }));

        // sourcing加量包
        let sourcingList = sourcingQuotaList.map((item, ind) => {
          return {
            ...item,
            ...one_package.sourcing[ind],
          };
        });
        setSourcingQuotaList(sourcingList);

        // 导入加量包
        let importList = importQuotaList.map((item, ind) => {
          return {
            ...item,
            ...one_package.import[ind],
          };
        });
        setPageLoading(false);
        setInitPage(false);
        setImportQuotaList(importList);
      }
    } catch (error) {}
  };

  // 升降级
  const handleMageUpgrade = async (
    id,
    val = "",
    email = "",
    social = "",
    am_id = ""
  ) => {
    try {
      let param = {
        package_id: id,
        email: email,
        social: social,
        am_id: am_id,
        is_yearly: 1,
      };
      if (val && val !== "") {
        param.remark = val;
      }

      setPageLoading(true);
      let res = await reqPostNewSubscribeChange(param);
      if (res.code === "200") {
        if (res?.data?.id !== "") {
          if (id !== 0) {
            toastFun(res.msg);
            setPageLoading(false);
            window.top.location.href = res.data.url;
          } else {
            //降级
            toastFun("Downgraded successfully");
          }
        } else {
          toastFun("Downgraded successfully");
          //降级
        }
      } else {
        setPageLoading(false);
        toastFun("Something wrong");
      }
    } catch (error) {}
  };
  // 获取套餐额度
  const getPackageQuota = async () => {
    try {
      let res = await reqGetNewSubscribeLimit();
      if (res.code === "200") {
        setPlanQuotaList(res.data);
      }
    } catch (error) {}
  };
  const isMount = useRef(null);
  useEffect(() => {
    if (!isMount.current) {
      getSubscribeList();
    }
    return () => {
      isMount.current = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const toggleToast = useCallback(() => setToast((toast) => !toast), []);
  const toastFun = (msg, error) => {
    setToastError(error);
    setToastMsg(msg);
    setToast(false);
    toggleToast();
  };
  const toastMarkup = toast ? (
    <Toast content={toastMsg} onDismiss={toggleToast} error={toastError} />
  ) : null;

  // 时间格式
  function formatTimestamp(timestamp) {
    const date = new Date(timestamp * 1000 + 8 * 3600 * 1000);
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const year = date.getUTCFullYear();
    const month = months[date.getUTCMonth()];
    const day = date.getUTCDate();

    return `${month} ${day}, ${year}`;
  }
  const quotaNumberFun = (number, quota) => {
    let num = 0;
    num = number;
    if (number > quota) {
      num = quota;
    }
    return num;
  };
  const trimTrailingZeros = (value) => {
    if (typeof value !== "string") return value;

    // 先去掉小数点右侧无用的 0
    value = value.replace(/\.0+$/, "").replace(/(\.\d*?[1-9])0+$/, "$1");

    return value;
  };
  let planContent = planData.list;
  const initSkeletonPage = (
    <div className="SettingsPage__Content skeleton_page">
      <div  className="skeleton_page_children">
      <Layout>
        <Layout.Section>
          <Card>
            <BlockStack gap={400}>
              <SkeletonBodyText lines={3} />
              <SkeletonBodyText lines={3} />
              <SkeletonBodyText lines={3} />
              <SkeletonBodyText lines={3} />
              <SkeletonBodyText lines={3} />
              <SkeletonBodyText lines={3} />
              <SkeletonBodyText lines={3} />
              <SkeletonBodyText lines={3} />
              <SkeletonBodyText lines={3} />
              <SkeletonBodyText lines={3} />
            </BlockStack>
          </Card>
        </Layout.Section>
      </Layout>
      </div>
    </div>
  );
  const pageContent = (
    <Box>
      <section className="Panel_Content">
        <BlockStack gap={300}>
          <Box>
            <Card>
              <BlockStack gap={200}>
                <InlineStack
                  align="space-between"
                  blockAlign="center"
                  gap={100}
                >
                  <Box className="plan_setting_current_text">Current plan</Box>
                  <Box>
                    <Button
                      onClick={() => {
                         store.dispatch(
                                setInitialPath("/admin/plan_setting")
                              );
                        if (shopify) {
                          handleModalCallback('/admin/subscribe','Plan_Page_Modal')
                        }else {
                        utils.routeJump1(router, `/admin/subscribe`);
                        }
                      }}
                    >
                      Change plan
                    </Button>
                  </Box>
                </InlineStack>
                <Box>
                  <Card>
                    <BlockStack gap={200}>
                      <Box>
                        <InlineStack gap={200} blockAlign="center">
                          <Box className="plan_setting_title">
                            {planContent.name}
                          </Box>
                          <Badge tone="info">
                            {planData.glassesLevel
                              ? "Year plan"
                              : "Monthly plan"}
                          </Badge>
                        </InlineStack>
                      </Box>
                      <InlineStack
                        align="space-between"
                        blockAlign="center"
                        gap={100}
                      >
                        <Box>
                          <InlineStack gap={150} blockAlign="baseline">
                            <Box className="plan_setting_price">
                              ${planContent.money}
                            </Box>
                            <Box className="plan_setting_month">
                              {!planData.glassesLevel
                                ? "USD/month"
                                : "USD/year"}
                            </Box>
                          </InlineStack>
                        </Box>
                        {!planData.glassesLevel && planContent.id > 0 && (
                          <Box>
                            <Button
                              variant="plain"
                              icon={DiscountIcon}
                              onClick={() => {
                                if (planContent.id === 5) {
                                  setPremiumData((prevValue) => ({
                                    ...prevValue,
                                    open: true,
                                  }));
                                } else {
                                  handleMageUpgrade(planContent.id);
                                }
                              }}
                            >
                              Pay yearly and save $
                              {trimTrailingZeros(((planContent.money * 12) - trimTrailingZeros(
                                planData.currentPlanYear.money
                              )).toFixed(2))}
                              /year
                            </Button>
                          </Box>
                        )}
                      </InlineStack>
                      {planData.bill_next_time !== 0 && (
                        <Box>
                         {planContent.name} plan {planData.glassesLevel > 0 ? "yearly" : "monthly"} renewal:{" "}
                          {formatTimestamp(planData?.bill_next_time || 0)}
                        </Box>
                      )}
                      {planContent.common.length > 0 && (
                        <Box>
                          <Box className="plan_item_common">
                            <Box className="plan_item_common_title">
                              Core benefits
                            </Box>
                            <ul>
                              {planContent.common.map((it, k) => (
                                <li key={k}>
                                  <span>.</span>
                                  {it}
                                </li>
                              ))}
                            </ul>
                          </Box>
                        </Box>
                      )}
                      <Box
                        style={{ border: "1px solid rgba(235, 235, 235, 1)" }}
                      ></Box>
                      <Box>
                        <Button
                          variant="tertiary"
                          onClick={() => setShowAllFeature(!showAllFeature)}
                        >
                          <InlineStack gap={100} blockAlign="center">
                            <span>View all feature</span>
                            <Icon source={showAllFeature ? ChevronUpIcon : ChevronDownIcon}></Icon>
                          </InlineStack>
                        </Button>
                      </Box>
                      <Box
                        className="plan_item_dsc"
                        style={{
                          maxHeight: showAllFeature ? "100%" : "0",
                          opacity: showAllFeature ? 1 : 0,
                          transition:
                            "max-height 0.3s ease, opacity 0.2s ease 0.1s",
                        }}
                      >
                        <ul style={{ margin:0 }}>
                          {planContent.dscList.map((desc, k) => (
                            <li key={k}>
                              <span>.</span>
                              {desc.p}
                            </li>
                          ))}
                        </ul>
                      </Box>
                    </BlockStack>
                  </Card>
                </Box>
                <Box>
                  <InlineStack>
                    <Box>
                      View the{" "}
                      <Link url="https://www.shopify.com/legal/terms" external>
                        terms of service
                      </Link>{" "}
                      and{" "}
                      <Link
                        external
                        url="https://www.dropshipman.com/privacy-policy"
                      >
                        privacy policy
                      </Link>
                    </Box>
                  </InlineStack>
                </Box>
              </BlockStack>
            </Card>
          </Box>
          <Box>
            <Card>
              <BlockStack gap={300}>
                <Box className="plan_item_title_weight">Quota</Box>
                {planData.reset_time !== 0 ? <Box>Next quota reset date: {formatTimestamp(planData.reset_time)}</Box>:<Box>Next quota reset date: On the 1st of each month</Box>}
                <Box>
                  <Card>
                      <BlockStack gap={200}>
                        <Box>
                          <InlineStack
                            align="space-between"
                            blockAlign="center"
                            gap={100}
                          >
                            <Box  className="plan_item_title_weight">Sourcing Requests</Box>
                            <InlineStack gap={200}>
                              <Button
                                variant="plain"
                                onClick={() => {
                                  utils.routeJump1(
                                    router,
                                    `/admin/product_selection?select_tab=2`
                                  );
                                }}
                              >
                              Start Sourcing
                              </Button>
                              <Button
                                onClick={() => {
                                  store.dispatch(
                                    setInitialPath("/admin/plan_setting")
                                  );
                                  if (shopify) {
                                    handleModalCallback('/admin/subscribe','Plan_Page_Modal',{ref:'sourcing_id'})
                                  }else {
                                    utils.routeJump1(
                                      router,
                                      `/admin/subscribe?ref=sourcing_id`
                                    );
                                  }
                                  
                                }}
                              >
                                Buy Quota
                              </Button>
                            </InlineStack>
                          </InlineStack>
                        </Box>
                        <Box>
                          <Box style={{ marginBottom: "5px" }}>
                          Included quota
                          </Box>
                          <Box>
                            <ProgressBar
                              progress={
                                (quotaNumberFun(
                                  planQuotaList.limit.sourcing +
                                    planQuotaList.limit.sourcing_job,
                                  planQuotaList.total.sourcing_num
                                ) /
                                  planQuotaList.total.sourcing_num) *
                                100
                              }
                              size="small"
                            />
                          </Box>
                          <Box>
                            <InlineStack align="flex-end">
                              <Box>
                                {quotaNumberFun(
                                  planQuotaList.limit.sourcing +
                                    planQuotaList.limit.sourcing_job,
                                  planQuotaList.total.sourcing_num
                                )}
                                /{planQuotaList.total.sourcing_num}
                              </Box>
                            </InlineStack>
                          </Box>
                        </Box>
                        {planQuotaList.total.add_sourcing > 0 ? (
                          <Box>
                            <Box style={{ marginBottom: "5px" }}>
                            Purchased quota
                            </Box>
                            <Box>
                              <ProgressBar
                                progress={
                                  (quotaNumberFun(
                                    planQuotaList.limit.use_sourcing,
                                    planQuotaList.total.add_sourcing
                                  ) /
                                    planQuotaList.total.add_sourcing) *
                                  100
                                }
                                size="small"
                              />
                            </Box>
                            <Box>
                              <InlineStack align="flex-end">
                                <Box>
                                  {quotaNumberFun(
                                    planQuotaList.limit.use_sourcing,
                                    planQuotaList.total.add_sourcing
                                  )}
                                  /{planQuotaList.total.add_sourcing}
                                </Box>
                              </InlineStack>
                            </Box>
                          </Box>
                        ) : (
                          ""
                        )}
                      </BlockStack>
                  </Card>
                </Box>
                <Card>
                      <BlockStack gap={200}>
                        <Box>
                          <InlineStack
                            align="space-between"
                            blockAlign="center"
                            gap={100}
                          >
                            <Box  className="plan_item_title_weight">Product Import Quota</Box>
                            <InlineStack gap={200}>
                              <Button
                                variant="plain"
                                onClick={() => {
                                  utils.routeJump1(
                                    router,
                                    `/admin/product_selection?select_tab=0`
                                  );
                                }}
                              >
                              Import Products
                              </Button>
                              <Button
                                onClick={() => {
                                  store.dispatch(
                                    setInitialPath("/admin/plan_setting")
                                  );
                                  // utils.routeListen(
                                  //   "/admin/subscribe?ref=import_id"
                                  // );
                                  if (shopify) {
                                    handleModalCallback('/admin/subscribe','Plan_Page_Modal',{ref:'import_id'})
                                  }else {
                                  utils.routeJump1(
                                    router,
                                    `/admin/subscribe?ref=import_id`
                                  );
                                }
                                }}
                              >
                                Buy Quota
                              </Button>
                            </InlineStack>
                          </InlineStack>
                        </Box>
                        {planQuotaList.total.add_product > 0 ? (
                          <Box>
                            <Box style={{ marginBottom: "5px" }}>
                              <InlineStack gap={100} blockAlign='center'>
                                <span>Purchased quota</span>
                                <Tooltip content="Valid for importing products from Dropshipman, AliExpress, and Temu.">
                                <span><Icon
                                  source={QuestionCircleIcon}
                                  tone="base"
                                /></span>
                              </Tooltip>
                              </InlineStack>
                            </Box>
                            <Box>
                              <ProgressBar
                                progress={
                                  (quotaNumberFun(
                                    planQuotaList.limit.use_product,
                                    planQuotaList.total.add_product
                                  ) /
                                    planQuotaList.total.add_product) *
                                  100
                                }
                                size="small"
                              />
                            </Box>
                            <Box>
                              <InlineStack align="flex-end">
                                <Box>
                                  {quotaNumberFun(
                                    planQuotaList.limit.use_product,
                                    planQuotaList.total.add_product
                                  )}
                                  /{planQuotaList.total.add_product}
                                </Box>
                              </InlineStack>
                            </Box>
                          </Box>
                        ) : (
                          ""
                        )}
                        <Box>
                          <Box style={{ marginBottom: "5px" }}>
                          Included Quota — Dropshipman  
                          </Box>
                          <Box>
                            <ProgressBar
                              progress={
                                (quotaNumberFun(
                                  planQuotaList.limit.dsm,
                                  planQuotaList.total.dsm_product_num
                                ) /
                                  planQuotaList.total.dsm_product_num) *
                                100
                              }
                              size="small"
                            />
                          </Box>
                          <Box>
                            <InlineStack align="flex-end">
                              <Box>
                                {quotaNumberFun(
                                  planQuotaList.limit.dsm,
                                  planQuotaList.total.dsm_product_num
                                )}
                                /{planQuotaList.total.dsm_product_num}
                              </Box>
                            </InlineStack>
                          </Box>
                        </Box>
                        <Box>
                          <Box style={{ marginBottom: "5px" }}>
                          Included Quota — AliExpress  
                          </Box>
                          <Box>
                            <ProgressBar
                              progress={
                                (quotaNumberFun(
                                  planQuotaList.limit.aliexpress +
                                    planQuotaList.limit.aliexpress_job,
                                  planQuotaList.total.ali_product_num
                                ) /
                                  planQuotaList.total.ali_product_num) *
                                100
                              }
                              size="small"
                            />
                          </Box>
                          <Box>
                            <InlineStack align="flex-end">
                              <Box>
                                {quotaNumberFun(
                                  planQuotaList.limit.aliexpress +
                                    planQuotaList.limit.aliexpress_job,
                                  planQuotaList.total.ali_product_num
                                )}
                                /{planQuotaList.total.ali_product_num}
                              </Box>
                            </InlineStack>
                          </Box>
                        </Box>
                        <Box>
                          <Box style={{ marginBottom: "5px" }}>
                          Included Quota — Temu
                          </Box>
                          <Box>
                            <ProgressBar
                              progress={
                                (quotaNumberFun(
                                  planQuotaList.limit.temu +
                                    planQuotaList.limit.temu_job,
                                  planQuotaList.total.temu_product_num
                                ) /
                                  planQuotaList.total.temu_product_num) *
                                100
                              }
                              size="small"
                            />
                          </Box>
                          <Box>
                            <InlineStack align="flex-end">
                              <Box>
                                {quotaNumberFun(
                                  planQuotaList.limit.temu +
                                    planQuotaList.limit.temu_job,
                                  planQuotaList.total.temu_product_num
                                )}
                                /{planQuotaList.total.temu_product_num}
                              </Box>
                            </InlineStack>
                          </Box>
                        </Box>
                      </BlockStack>
                  </Card>
              </BlockStack>
            </Card>
          </Box>
        </BlockStack>
      </section>
    </Box>
  );
  return (
    <Box
      id="settings_class"
    >
      <Page title={ shopify ? '' : intl.get("Settings")} separator>
        {/* <section className="SettingsPage__Box">
          <NavTabs selected="Plan" />
          
        </section> */}
        {initPage && initSkeletonPage}
        <div style={{opacity: initPage ? 0 : 1}}>
        {pageContent}
      </div>
        {toastMarkup}
        {pageLoading && <SearchLoading />}
        <PersonalAgentModal
          premiumData={premiumData}
          handlePremiumOff={handlePremiumOff}
          handleMageUpgrade={handleMageUpgrade}
        />
        <div className="space"></div>
      </Page>
    </Box>
  );
};
const importRecharge = [
  {
    price: "10",
    badge: "products",
    symbol: "$",
    desc: "per product",
    time: "3 months validity",
    button: "Recharge",
    loading: false,
    disabled: false,
  },
  {
    price: "30",
    badge: "products",
    symbol: "$",
    desc: "per product",
    time: "3 months validity",
    button: "Recharge",
    loading: false,
    disabled: false,
  },
  {
    price: "50",
    badge: "products",
    symbol: "$",
    desc: "per product",
    time: "3 months validity",
    button: "Recharge",
    loading: false,
    disabled: false,
  },
];
const sourcingRecharge = [
  {
    price: "15",
    badge: "sourcing requests",
    symbol: "$",
    desc: "per sourcing",
    time: "3 months validity",
    button: "Recharge",
    loading: false,
    disabled: false,
  },
  {
    price: "60",
    badge: "sourcing requests",
    symbol: "$",
    desc: "per sourcing",
    time: "3 months validity",
    button: "Recharge",
    loading: false,
    disabled: false,
  },
  {
    price: "90",
    badge: "sourcing requests",
    symbol: "$",
    desc: "per sourcing",
    time: "3 months validity",
    button: "Recharge",
    loading: false,
    disabled: false,
  },
];
export default PlanClass;
